import { render, staticRenderFns } from "./RecordItem.vue?vue&type=template&id=a48cf0b4"
import script from "./RecordItem.vue?vue&type=script&lang=js"
export * from "./RecordItem.vue?vue&type=script&lang=js"
import style0 from "./RecordItem.vue?vue&type=style&index=0&id=a48cf0b4&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports